import React from 'react';
import OverlayTrigger, { OverlayTriggerType } from 'react-bootstrap/esm/OverlayTrigger';
import { Placement } from 'react-bootstrap/esm/types';
import Tooltip from 'react-bootstrap/Tooltip';
import { isNumeric } from '../../../util/util';
import classNames from 'classnames';

interface TooltipBoxProps {
  children: React.ReactElement;
  trigger?: OverlayTriggerType | OverlayTriggerType[];
  show?: boolean;
  defaultShow?: boolean;
  onToggle?: (nextShow: boolean) => void;
  placement?: Placement;
  id?: string;
  msg?: string;
  closeOnOutsideClick?: boolean;
  hideDelay?: number;
  contentClassName?: string;
}

const TooltipBox = React.forwardRef<TooltipBoxProps, any>(
  ({ children, trigger = ['hover', 'focus'], placement = 'top', id, msg, closeOnOutsideClick, hideDelay, contentClassName }, ref) => {
    const popoverElement = (
      <Tooltip id={id} className={classNames("crt-tooltip", contentClassName ?? '')} style={{ position: 'fixed' }}>
        <React.Fragment>{msg}</React.Fragment>
      </Tooltip>
    );

    return (
      <OverlayTrigger
        delay={{ show: 300, hide: closeOnOutsideClick ? 0 : isNumeric(hideDelay) ? hideDelay  : 300 }}
        trigger={trigger}
        placement={placement}
        overlay={popoverElement}
        rootClose={closeOnOutsideClick}
        
      >
        {children}
      </OverlayTrigger>
    );
  },
);

TooltipBox.displayName = 'TooltipBox';

export default TooltipBox;
